module.exports = __webpack_public_path__ + "static/media/alfred_makoto_kabayama.fd613041.jpg";